
import { AssetSchema } from 'cms/schemaTypes/generalSchemas/assets'

import Breadcrumbs from 'shared/ui/Breadcrumbs'
import { PATHS } from 'shared/utils/paths'

import LandingsBanner from '../landings/LandingsBanner'
import { SectionContainer } from '../landings/styles'

interface AboutUsBannerSectionProps {
  banner: {
    desktop: AssetSchema
    mobile: AssetSchema
  }
}
export default function AboutUsBannerSection({
  banner
}: AboutUsBannerSectionProps) {
  return (
    <>
      <SectionContainer>
        <Breadcrumbs
          breadcrumbs={[
            { label: 'Strona główna', path: PATHS.home },
            { label: 'O nas', path: PATHS.aboutUs }
          ]}
        />
      </SectionContainer>
      <LandingsBanner banner={banner} />
    </>
  )
}
